module.exports = __webpack_public_path__ + "img/prioritas_bosspack_dfod_k.7e582fa8.png";